import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
Vue.prototype.$http = axios;
Vue.config.productionTip = false


const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', component: App },
  ]
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
